/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Scope_Profile_Email_DescInputs */



/**
* | output |
* | --- |
* | "Read basic profile and the member's verified email address" |
*
* @param {Developer_Scope_Profile_Email_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_scope_profile_email_desc = /** @type {((inputs?: Developer_Scope_Profile_Email_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Scope_Profile_Email_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lire le profil de base et l'adresse e-mail vérifiée du membre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Leer el perfil básico y el correo electrónico verificado del miembro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ler o perfil básico e o e-mail verificado do membro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Leggere il profilo base e l'indirizzo email verificato del membro")
	return /** @type {LocalizedString} */ ("Read basic profile and the member's verified email address")
});